<template>
  <div class="recruit">
    <img src="../assets/images/pic_Yello@2x.png" class="sector" />
    <div class="recruit_box">
      <div class="newBox">
        <div class="title_box1">
          <p class="recruit2_text" align="left">表情包</p>
        </div>
        <!-- <div class="recruit1_label">
          <div class="label_item2" @click="Btnitem(1)">
            <p class="itemName">Pico猫</p>
            <img src="../assets/images/pico10.png" alt="" />
            <p class="name">10元/组 <a>点击查看</a></p>
          </div>
          <div class="label_item2" @click="Btnitem(5)">
            <p class="itemName">鸡哥-圣诞版</p>
            <img src="../assets/images/pico50.png" alt="" />
            <p class="name">10元/组 <a>点击查看</a></p>
          </div>
      
        </div> -->

        <!-- 表情包列表 -->
        <div class="emoji-scroll">
          <div class="list-view">
            <div
              v-for="(item, index) in emojiList"
              :key="index"
              class="item-view"
              @click="lookDetail(item)"
            >
            <div class="img-border">
              <img :src="item.thumbnail" oncontextmenu="return false;" />

            </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>

        <div class="title_box1">
          <p class="recruit2_text" align="left">漫画及衍生品</p>
        </div>

        <div class="emoji-scroll">
          <div class="list-view">
            <div
              v-for="(item, index) in productList"
              :key="index"
              class="item-view"
              @click="lookDetail(item)"
            >
            <div class="img-border">
              <img :src="item.thumbnail" oncontextmenu="return false;" />

            </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="bask" @click="bask" v-if="baskBg">
        <h1>
          仅可查看表情部分内容，需登录付费后下载高清表情，点击付费下载按钮进行付费。
        </h1>
        <div class="images1" v-if="active == 1">
          <img src="../assets/images/pico10.png" alt="" />
          <img src="../assets/images/pico11.png" alt="" />
          <img src="../assets/images/pico12.png" alt="" />
          <img src="../assets/images/pico13.png" alt="" />
          <img src="../assets/images/pico14.png" alt="" />
          <img src="../assets/images/pico15.png" alt="" />
        </div>
        <div class="images1" v-if="active == 2">
          <img src="../assets/images/pico20.png" alt="" />
          <img src="../assets/images/pico21.png" alt="" />
          <img src="../assets/images/pico22.png" alt="" />
          <img src="../assets/images/pico23.png" alt="" />
          <img src="../assets/images/pico24.png" alt="" />
        </div>
        <div class="images1" v-if="active == 3">
          <img src="../assets/images/pico30.png" alt="" />
          <img src="../assets/images/pico31.png" alt="" />
          <img src="../assets/images/pico32.png" alt="" />
          <img src="../assets/images/pico33.png" alt="" />
          <img src="../assets/images/pico34.png" alt="" />
          <img src="../assets/images/pico35.png" alt="" />
        </div>
        <div class="images1" v-if="active == 4">
          <img src="../assets/images/pico40.png" alt="" />
          <img src="../assets/images/pico41.png" alt="" />
          <img src="../assets/images/pico42.png" alt="" />
          <img src="../assets/images/pico43.png" alt="" />
          <img src="../assets/images/pico44.png" alt="" />
          <img src="../assets/images/pico45.png" alt="" />
          <img src="../assets/images/pico46.png" alt="" />
          <img src="../assets/images/pico47.png" alt="" />
          <img src="../assets/images/pico48.png" alt="" />
          <img src="../assets/images/pico49.png" alt="" />
          <img src="../assets/images/pico411.png" alt="" />
          <img src="../assets/images/pico412.png" alt="" />
          <img src="../assets/images/pico413.png" alt="" />
        </div>
        <div class="images1" v-if="active == 5">
          <img src="../assets/images/pico50.png" alt="" />
          <img src="../assets/images/pico51.png" alt="" />
          <img src="../assets/images/pico52.png" alt="" />
          <img src="../assets/images/pico53.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../servies/api";
export default {
  data() {
    return {
      emojiList: [],
      productList: [],
      active: 5,
      baskBg: false,
      qr: "", // 二维码
    };
  },
  mounted() {
    console.log("产品组件初始化");
    this.getProducts();
  },
  methods: {
    lookDetail(item) {
      // 本地存储一个object
      item.qr = this.qr;
      localStorage.setItem("product", JSON.stringify(item));
      this.$router.push("detail");
    },
    getProducts() {
      api
        .getGoodsList()
        .then((res) => {
          console.log("获取产品成功", res);
          if (res.code !== 0) {
            return;
          }
          this.emojiList = res.resultData.emoji;
          this.productList = res.resultData.comics;
          this.qr = res.resultData.qr;
        })
        .catch((err) => {
          console.log("获取产品失败", err);
        });
    },
    Btnitem(num) {
      console.log(num);
      this.active = num;
      this.baskBg = true;
    },
    bask() {
      this.baskBg = !this.baskBg;
    },
  },
};
</script>
<style lang="less">
// 去除页面滚动条

::-webkit-scrollbar {
  display: none;
}
.recruit {
  width: 100%;
  // background: #F7F7F7;
  // overflow: hidden;
  height:fit-content;
   padding-bottom: 70px;
  
  .sector {
    width: 780px;
    position: absolute;
  }
  .recruit_box {
    max-width: 1300px;
    min-width: 980px;
    min-height: 100vh;
    margin: 0 auto;
    //  padding-bottom: 70px;
    position: relative;
    .title_box {
      width: 500px;
      height: 60px;
      position: absolute;
      top: 150px;
      left: 120px;
      .recruit_title {
        width: 44%;
        vertical-align: middle;
      }
    }
  }
}
.newBox {
  padding: 100px;
  .emoji-scroll {
    width: 100%;
    overflow-x: scroll;
    margin-top: 50px;
    .list-view {
      display: flex;
      width: 800px;
      margin: 0 auto;
      flex-wrap: wrap;
      justify-content: space-between;
      .item-view {
        width: 240px;
        height: 240px;

        margin-bottom: 50px;
        .img-border {
          width: 240px;
          height: 240px;
          border: 2px solid #000;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 220px;
            height: 220px;
            display: block;
            object-fit: cover;
          }
        }

        span {
          display: block;
          text-align: center;
          width: 240px;
          margin-top: 15px;
        }
      }
    }
  }
  .recruit2_text {
    width: 100%;
    font-size: 40px;
    text-align: center;
    display: inline-block;
    margin-left: 14px;
    line-height: 40px;
    vertical-align: middle;
    margin-top: 50px;
  }
  .recruit1_label {
    min-width: 850px;
    max-width: 1100px;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: 280px;
    display: flex;
    justify-content: space-around;
    .label_item2 {
      width: 22%;
      margin: 20px;
      margin-bottom: 70px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 2px solid #000;
      padding: 20px;
      img {
        width: 100%;
        box-sizing: border-box;
        border-radius: 10px;
        padding: 4px;
      }
    }
  }
}
.bask {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  h1 {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    margin-top: 20px;
  }
  .images1 {
    width: 100%;
    padding: 50px;
    img {
      width: 148px;
      margin: 20px;
      border: 1px solid #ffffff;
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Series.vue